import React from "react";
import "./Footer.css"

function Footer() {

    return(
    <>
        <div className="FooterPositionFixed textColor">
            <div className="FooterFlexCenter">
            <a href="https://www.linkedin.com/in/paulo-j-santos/" target="_blank"><img src="/linked.png" alt="Github Logo" className="footerIcons" /> </a>
            <a href="https://github.com/Jorge-Neves" target="_blank"><img src="/githublogo.png" alt="LinkedIn Logo" className="footerIcons" /> </a>
    
            </div>
        </div>
    </>
    )


}

export default Footer; 